//import { groups } from "@/api/mock_groups";
import { mapGetters } from "vuex";
// import apiService from "../../../api/api.service";

import rules from "../../../utils/rules";
import countryPhoneCodes from "../../../utils/countryPhoneCodes.json";
import app from "../../../utils/app.json";
import InfoDialog from "@/components/InfoDialog";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
export default {
  name: "access-control-operators-management",
  components: { InfoDialog, pageheader },
  props: [],
  data() {
    return {
      type: "Customer",
      cellCountryCode: "1",
      cellCountryName: "us",
      isGetGroupAccessKeys: false,
      selectedCustomer: null,
      selectedCustomerName: "",
      isLoaderCustGroup: false,
      searchCustomerGroup: null,
      isLoaderMachine: false,
      isLoaderGroup: false,
      accessKeysMode: false,
      accessCode: "",
      isloading: false,
      countryPhoneCodes,
      machineSearchFilter: "",
      group: {
        isValid: true,
        role: "",
        customer: {},
      },
      selectedCustomernew: "All",
      customerListNew: [
        {
          id: null,
          name: "All",
        },
      ],
      valid: true,
      editing: false,
      rules: rules,
      role: [],
      authRole: "",
      provider: "Standard",
      customerList: [],
      machinesList: [],
      groupsList: [],
      customerIDs: [],
      machines: [],
      confirmPasswordRules: [
        (value) => !!value || "Confirm password is required",
        (value) =>
          value === this.group.password ||
          "The password confirmation does not match.",
      ],
      formType: "",
      loading: false,
      input: {},
      searchCustomer: null,
      searchMachine: null,
    };
  },
  watch: {
    "$route.query.type": {
      handler: function (type) {
        this.formType = type;
      },
    },
    searchCustomer(val) {
      // Items have already been loaded
      //if (this.parentCompaniesList.length > 1) return;

      // Items have already been requested
      //if (this.isLoaderCustGroup) return;

      //check entered text is not undefined and enter search text is multiples of 2 characters
      if (val != undefined && val != "All" && val.length % 2 == 0) {
        this.searchCustomers(val);
      }
    },
    searchMachine(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  created() {
    // this.getBasicCustomers();
    if ("id" in this.$route.params) {
      this.getOperatorsById();
      this.editing = true;
    } else {
      this.clearForm();

      this.getCustomerAccessEnabled();
    }

    // if (this.roles != "Customer") {
    //   this.type = "Personal";
    // } else {
    //   this.type = "Customer";
    // }
  },
  computed: {
    ...mapGetters(["roles", "basicCustomers", "companyIdDropdown"]),
  },
  mounted() {
    this.input = utils.getInputContent("accessControl", this.roles);
    if (this.roles == "Admin" || this.roles == "Birch User") {
      this.authRole = app.userRoles;
    } else if (this.roles == "Customer") {
      this.authRole = app.userRoles.filter(
        (x) => x != "Admin" && x != "Birch User",
      );
    }
    // if (this.roles == "Developers") {
    //   this.authRole = app.groupRoles.filter((x) => x != "Admin");
    // } else if (this.roles == "Admin" || this.roles == "Birch User") {
    //   this.authRole = app.groupRoles;
    // } else {
    //   this.authRole = app.groupRoles.filter(
    //     (x) => x != "Admin" && x !== "Developers"
    //   );
    // }
    if (this.formType == "") {
      // this.getMachine();
      this.getGroupControlOperatorsList();
      this.clearForm();
    }
  },
  methods: {
    onSelectOffice({ name, iso2, dialCode }) {
      this.cellCountryCode = dialCode;
      this.cellCountryName = iso2;
      console.log(name, iso2, dialCode);
    },
    remove(item) {
      const index = this.group.machines.indexOf(item.stockKey);
      if (index >= 0) this.group.machines.splice(index, 1);
    },
    async searchCustomers(value) {
      try {
        this.isLoaderCustGroup = true;
        const response = await telematicsService.searchBasicCustomers(value);
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.customerList = finaldata;
          this.isLoaderCustGroup = false;
        } else {
          this.isLoaderCustGroup = false;
        }
      } catch (err) {
        this.isLoaderCustGroup = false;
        console.log(err);
      }
    },
    async getCustomerAccessEnabled() {
      this.isCustomerLoading = true;
      let customerId;
      if (this.editing == true) {
        customerId = String(this.selectedCustomer);
      } else {
        customerId = String(this.companyIdDropdown);
      }

      if (customerId != null && customerId != "") {
        try {
          let response = await telematicsService.getCustomerListById(
            customerId,
          );
          if (response.isSuccess) {
            this.accessKeysMode = response.data.accessKeysMode
              ? response.data.accessKeysMode
              : false;
            this.isCustomerLoading = false;
          }
          // {
        } catch (err) {
          console.log(err);
        }

        // },
      }
    },
    async searchCustomersBy(value) {
      try {
        this.isLoaderCustGroup = true;
        const response = await telematicsService.searchBasicCustomers(value);
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.customerList = finaldata;
          this.isLoaderCustGroup = false;
        } else {
          this.isLoaderCustGroup = false;
        }
      } catch (err) {
        this.isLoaderCustGroup = false;
        console.log(err);
      }
    },

    // custChange(){
    //   if(this.group.name){
    //     this.getMachine(this.group.id);
    //   }
    // },
    async getOperatorsById() {
      // this.isloading = false;

      try {
        this.isloading = true;
        let response = await telematicsService.getOperatorById(
          this.$route.params.id,
        );
        if (response.data) {
          this.isloading = false;
          this.group = response.data;
          this.group.groupName = response.data.email;
          this.group.customer = response.data.customers;
          this.group.isAllEquipments = response.data.allEquipments;
          this.getGroupControlOperatorsList();

          this.group.groups = response.data.groupId;
          this.type = String(response.data.type);
          // this.customerList = response.data.customers;
          // this.selectedCustomer=5704;
          if (
            response.data.customerId == null ||
            response.data.customerId == "" ||
            response.data.customerId == "null"
          ) {
            this.selectedCustomer = null;
          } else {
            this.selectedCustomer = Number(response.data.customerId);
            this.selectedCustomerName = response.data.customerName;
          }
          // let mdata = response.data.machines;
          //  this.machines = this.machinesList.filter((e) => (mdata.includes(e.tuUnitId)))
          // this.group.machines = response.data.machines
          // this.getMachine();
          this.group.machines = response.data.machines;
          this.group.accessCode = response.data.accessCode;
          this.formType = "edit";

          this.getCustomerAccessEnabled();
          this.searchMachines();
        } else {
          this.isloading = false;
          this.group = {};
        }
        this.formType = "edit";
      } catch (err) {
        this.loading = false;
        console.log("error", err);
      }
      // this.group.firstName = "Test Access Control";
      // this.group.lastName = "Operators";
      // this.groupsList = [{ mName: "Group1", stockKey: 12345 }];
      // this.group.groups = [{ mName: "Group1", stockKey: 12345 }];
      // this.group.email = "adminuser@incus5.com";
      // this.group.group = "Group1";
      // this.group.accessCode = "12345";
      // this.selectedCustomerName = "Industrial LLC";
    },
    async getGroupControlOperatorsList() {
      this.isGetGroupAccessKeys = true;
      this.groupsList = [];
      try {
        let response = await telematicsService.getGroupControlOperatorsList();
        if (response && response.data) {
          this.isGetGroupAccessKeys = false;
          this.groupsList = response.data;
        } else {
          this.isGetGroupAccessKeys = false;
          // this.$toast.error("No access codes available");
          this.groupsList = [];
        }
      } catch (err) {
        this.isGetGroupAccessKeys = false;
        console.log(err);
      }
    },
    validateForm() {
      let isFormValid = false;
      if (
        (this.group.machines != undefined &&
          this.group.machines &&
          this.group.machines.length > 0) ||
        (this.group.groups != null &&
          this.group.groups != "" &&
          this.group.groups != undefined) ||
        this.group.isAllEquipments
      ) {
        isFormValid = true;
      } else {
        this.$toast.error("Please select at least one equipment / one group");
      }

      return isFormValid;
    },
    async groupSave() {
      if (this.$refs.form.validate() && this.validateForm()) {
        let userPhoneNumber = this.group.phoneNumber.replace(/\D+/g, "");

        this.loading = true;
        // let groupmachineIDs=[];
        // this.group.machines.map(item=>{
        //   groupmachineIDs.push(item.tuUnitId);
        // })
        let payload1 = {
          firstName: this.group.firstName,
          lastName: this.group.lastName,
          email: this.group.email,
          phoneNumber: userPhoneNumber,
          countryCode: this.cellCountryCode,
          countryName: this.cellCountryName,
          accessCode: this.group.accessCode,
          customerId: String(this.selectedCustomer),
          groupId: this.group.groups != undefined ? this.group.groups : "",

          machines:
            this.machinesList.length > 0
              ? this.group.machines
                ? this.group.machines.map(String).join(",")
                : ""
              : "",
          allEquipments: this.group.isAllEquipments || false,
        };
        let payload2 = {
          firstName: this.group.firstName,
          lastName: this.group.lastName,
          email: this.group.email,
          phoneNumber: userPhoneNumber,
          countryCode: this.cellCountryCode,
          countryName: this.cellCountryName,
          customerId: String(this.companyIdDropdown),
          groupId: this.group.groups != undefined ? this.group.groups : "",
          accessCode: this.group.accessCode,
          machines: this.group.machines
            ? this.group.machines.map(String).join(",")
            : "",
          allEquipments: this.group.isAllEquipments || false,
        };
        try {
          var apiResponse;
          if (this.formType == "edit") {
            payload1.id = this.$route.params.id;
            apiResponse = await telematicsService.updateOperator(
              this.$route.params.id,
              payload1,
            );
          } else {
            apiResponse = await telematicsService.createOperator(payload2);
          }
          if (apiResponse.isSuccess) {
            this.loading = false;
            this.$refs.form.reset();
            this.$toast.success(apiResponse.systemMessage);
            this.$router.push({
              path: "/access-control/operators",
            });
          } else {
            this.loading = false;
            this.$toast.error(apiResponse.systemMessage);
          }
        } catch (err) {
          this.loading = false;
          this.$toast.error("Unable to create group" + err);
        }
      }
    },

    reset() {
      this.$refs.form.reset();
      this.$router.push({
        path: "/access-control/operators",
      });
    },
    clearForm() {
      this.group = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        officePhone: "",
        groupName: "",
        password: "",
        provider: this.provider,
        role: "",
      };
    },
    updateRouterParams() {
      this.$router.push("/access-control/operators");
    },
    async searchMachines(value) {
      this.isLoaderMachine = true;
      this.machinesList = [];
      let cust;
      if (this.formType == "edit") {
        cust = this.selectedCustomer;
      } else {
        cust = this.companyIdDropdown;
      }
      try {
        let response = await telematicsService.getSearchMachines(cust, value);
        if (response.isSuccess) {
          let tempMachines = response.data.map(function (element) {
            return {
              macStockKey: element.stockKey ? element.stockKey + ", " : "",
              macStockName: element.stockKey ? element.stockName : "",
              macName: !element.stockKey ? element.name + ", " : "",
              lineItemId: element.lineItemId ? element.lineItemId : "",
              model: element.model ? element.model : "",
              name: element.name ? element.name : "",
              stockDetails: element.stockDetails ? element.stockDetails : "",
              stockKey: element.stockKey ? element.stockKey : "",
              stockName: element.stockName ? element.stockName : "",
              tuUnitId: element.tuUnitId ? element.tuUnitId : "",
              assetId: element.assetId ? element.assetId : "",
            };
          });
          this.machinesList = tempMachines.map(function (element) {
            return {
              mName:
                element.macStockKey + element.macStockName + element.macName,
              lineItemId: element.lineItemId ? element.lineItemId : "",
              model: element.model ? element.model : "",
              name: element.name ? element.name : "",
              stockDetails: element.stockDetails ? element.stockDetails : "",
              stockKey: element.stockKey ? element.stockKey : "",
              stockName: element.stockName ? element.stockName : "",
              tuUnitId: element.tuUnitId ? element.tuUnitId : "",
              assetId: element.assetId ? element.assetId : "",
            };
          });
          this.isLoaderMachine = false;
        } else {
          this.machinesList = [];

          this.isLoaderMachine = false;
        }
      } catch (err) {
        this.loading = false;
        this.machinesList = [];

        this.isLoaderMachine = false;

        console.log("error", err);
      }
      // this.groupsList = [{ mName: "Group1", stockKey: 12345 }];
    },
  },
};
